import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  MessageOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import type { ComponentType } from "react";
import { useTranslation } from "react-i18next";
import type { AssistantConfidence } from "../../../api/assistant";

// Етикетът от първия ред на отговора като значка (правилата в BE
// `app/features/assistant/prompt.py` §СТЕПЕН НА СИГУРНОСТ). Тоналните тинтове
// са от семантичната палитра — зелено/кехлибар/сиво/синьо, без нов цвят.
const CONFIDENCE_STYLES: Record<
  AssistantConfidence,
  { labelKey: string; className: string; Icon: ComponentType<{ className?: string }> }
> = {
  confirmed: {
    labelKey: "monitoring.confidenceConfirmed",
    className: "bg-ok-tint text-ok-deep",
    Icon: CheckCircleOutlined,
  },
  likely: {
    labelKey: "monitoring.confidenceLikely",
    className: "bg-brand-tint text-brand-deep-ink",
    Icon: ExclamationCircleOutlined,
  },
  unknown: {
    labelKey: "monitoring.confidenceUnknown",
    className: "bg-fill text-body",
    Icon: QuestionCircleOutlined,
  },
  clarify: {
    labelKey: "monitoring.confidenceClarify",
    className: "bg-info-tint text-info-deep",
    Icon: MessageOutlined,
  },
};

export const ConfidenceBadge = ({ confidence }: { confidence: AssistantConfidence }) => {
  const { t } = useTranslation();
  const { labelKey, className, Icon } = CONFIDENCE_STYLES[confidence];
  return (
    <span
      data-confidence={confidence}
      className={`inline-flex items-center gap-[6px] self-start rounded-full px-[10px] py-[3px] text-[12px] font-semibold leading-[1.4] ${className}`}
    >
      <Icon className="!text-[13px]" />
      {t(labelKey)}
    </span>
  );
};
